import { BILLABLE_STATUSES, JOB_TYPES } from "@/lib/constants";
import { Tooltip, TooltipContent, TooltipTrigger } from "ui/components/tooltip";
import { differenceInDays, parseISO } from "date-fns";
import { Avatar } from "ui/components/avatar";
import { Badge } from "ui/components/badge";
import { DisplayAmount } from "components/display/amount";
import { Icon } from "components";
import { Link } from "react-router-dom";
import { RenderAvatar } from "components/render-avatar";
import { formatDateForDisplay } from "@/lib/utils";
import { maskPrivacyAmount } from "utils/utils";
import { usePrivacy } from "contexts/privacy";

export const NameCell = ({ row }) => {
  const name = row.getValue("name");
  return (
    <div className="space-y-1" title={name}>
      <div>{name ?? "__"}</div>
    </div>
  );
};

export const ExtensionCell = ({ row }) => {
  const billingDate = row.original.billing_date;
  const extensions = row.original.extensions;

  let extensionDays = null;

  const firstExtension = extensions[0].start_date;
  if (firstExtension) {
    extensionDays = Math.abs(
      differenceInDays(parseISO(firstExtension), parseISO(billingDate)),
    );
  }

  return (
    <div className="space-y-1" title={name}>
      <div>{extensionDays} days</div>
    </div>
  );
};

export const StatusCell = ({ getValue }) => {
  const status = BILLABLE_STATUSES[getValue()];
  if (!status) return null;
  return <Badge className={status.className}>{status.label}</Badge>;
};

export const TypeCell = ({ getValue }) => {
  return (
    <Tooltip>
      <TooltipTrigger>
        <Icon
          icon={JOB_TYPES[getValue()].icon}
          className="text-muted-foreground size-4"
        />
      </TooltipTrigger>
      <TooltipContent>{JOB_TYPES[getValue()].label}</TooltipContent>
    </Tooltip>
  );
};

export const AmountCell = ({ row }) => {
  const { privacyOn } = usePrivacy();
  let { amount, currency } = row.original;
  const currencyName = currency?.name || currency || "";
  amount = Number(amount);
  if (!amount) return null;
  return (
    <Tooltip>
      <TooltipTrigger>
        <div>
          {privacyOn ? (
            maskPrivacyAmount(amount)
          ) : (
            <>
              <DisplayAmount value={amount} />{" "}
              {currencyName && `${currencyName}`}
            </>
          )}
        </div>
      </TooltipTrigger>
      <TooltipContent>
        {privacyOn
          ? maskPrivacyAmount(amount)
          : `Amount: ${amount} ${currencyName}`}
      </TooltipContent>
    </Tooltip>
  );
};

export const AmountCell2 = ({ getValue }) => {
  if (!getValue() && getValue() !== 0) return null;

  return <DisplayAmount value={getValue()} />;
};

export const AdjustedAmountCell = ({ row }) => {
  const { privacyOn } = usePrivacy();
  let { adjusted_amount, currency } = row.original;
  const currencyName = currency?.name || currency || "";
  adjusted_amount = Number(adjusted_amount);
  if (!adjusted_amount) return null;
  return (
    <div>
      {privacyOn ? (
        maskPrivacyAmount(adjusted_amount)
      ) : (
        <>
          <DisplayAmount value={adjusted_amount} />{" "}
          {currencyName && `${currencyName}`}
        </>
      )}
    </div>
  );
};

export const ProjectCell = (info) => {
  const project = info.getValue();
  if (!project) return null;
  return (
    <div>
      <div>{project}</div>
    </div>
  );
};

export const JobCell = (info) => {
  const { getValue } = info;

  return (
    <div>
      <div>{getValue()}</div>
    </div>
  );
};

export const DateCell = (info) =>
  formatDateForDisplay(info.getValue(), { addSuffix: true });

